/*
 * Breadcrumb + page title header for CreateEditIntakeView.
 *
 * Replaces the giant's inline `ceiv-breadcrumb*` markup with the shared <Breadcrumb>.
 *   edit:   Management › Intake forms › {title} › Edit   |  title row "Edit · {title}"
 *   create: Management › Intake forms › New intake       |  title row "New intake form"
 *
 * SCSS → Tailwind (ceiv-title): font-size:24px / font-weight:600 / line-height:32px /
 *   color:--text-dark(#253845) / margin:0 → text-size-6 font-semibold leading-8 text-text-dark m-0
 */
import { useNavigate } from 'react-router-dom'
import { MANAGEMENT_PAGE_ROUTE } from '../../../../../../utils/constants'
import { tabValues, searchParamsKeys } from '../../../../constants'
import { Breadcrumb } from '@/components/breadcrumb/Breadcrumb'
import type { Crumb } from '@/components/breadcrumb/Breadcrumb'

type Props = {
  isEdit?: boolean | undefined
  title?: string | undefined
  onTitleCrumbClick?: (() => void) | undefined
}

export function IntakeBreadcrumbHeader({ isEdit, title, onTitleCrumbClick }: Props) {
  const navigate = useNavigate()
  const intakeFormsUrl = `${MANAGEMENT_PAGE_ROUTE}?${searchParamsKeys.ACTIVE_TAB}=${tabValues.INTAKE_FORMS}`

  const crumbs: Crumb[] =
    isEdit ?
      [
        {
          label: 'Management',
          onClick: () => {
            void navigate(MANAGEMENT_PAGE_ROUTE)
          },
        },
        {
          label: 'Intake forms',
          onClick: () => {
            void navigate(intakeFormsUrl)
          },
        },
        { label: title ?? '', onClick: onTitleCrumbClick },
        { label: 'Edit' },
      ]
    : [
        {
          label: 'Management',
          onClick: () => {
            void navigate(MANAGEMENT_PAGE_ROUTE)
          },
        },
        {
          label: 'Intake forms',
          onClick: () => {
            void navigate(intakeFormsUrl)
          },
        },
        { label: 'New intake' },
      ]

  return (
    <>
      <Breadcrumb crumbs={crumbs} />
      <h1 className='m-0 text-size-6 font-semibold leading-8 text-text-dark'>
        {isEdit ? `Edit · ${title ?? ''}` : 'New intake form'}
      </h1>
    </>
  )
}
